import React from 'react';
import { useTranslation } from 'react-i18next';

function Support() {
  const { t } = useTranslation();

  return (
    <div className="pt-16">
      <div className="bg-white py-16 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-24">
        <div className="relative max-w-xl mx-auto">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              {t('support.title')}
            </h2>
            <p className="mt-4 text-lg leading-6 text-gray-500">
              {t('support.subtitle')}
            </p>
          </div>

          <div className="mt-12">
            <div className="bg-gray-50 rounded-lg p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6">
                {t('support.deleteAccount.title')}
              </h3>

              <div className="space-y-6">
                <div>
                  <p className="text-gray-700 mb-4">
                    {t('support.deleteAccount.description')}
                  </p>

                  <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <h3 className="text-sm font-medium text-blue-800">
                          {t('support.deleteAccount.steps.title')}
                        </h3>
                        <div className="mt-2 text-sm text-blue-700">
                          <ol className="list-decimal list-inside space-y-2">
                            <li>{t('support.deleteAccount.steps.step1')}</li>
                            <li>{t('support.deleteAccount.steps.step2')}</li>
                            <li>{t('support.deleteAccount.steps.step3')}</li>
                          </ol>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-6">
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">
                    {t('support.deleteAccount.thirdParty.title')}
                  </h4>
                  <p className="text-gray-700 mb-4">
                    {t('support.deleteAccount.thirdParty.description')}
                  </p>

                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div className="bg-white border border-gray-200 rounded-md p-4">
                      <h5 className="font-medium text-gray-900">Google</h5>
                      <p className="text-sm text-gray-600 mt-1">
                        {t('support.deleteAccount.thirdParty.google')}
                      </p>
                    </div>
                    <div className="bg-white border border-gray-200 rounded-md p-4">
                      <h5 className="font-medium text-gray-900">Facebook</h5>
                      <p className="text-sm text-gray-600 mt-1">
                        {t('support.deleteAccount.thirdParty.facebook')}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-6">
                  <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <h3 className="text-sm font-medium text-yellow-800">
                          {t('support.deleteAccount.warning.title')}
                        </h3>
                        <div className="mt-2 text-sm text-yellow-700">
                          <p>{t('support.deleteAccount.warning.description')}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 text-center">
              <a
                href="mailto:support@tenkusports.com"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
              >
                <svg className="mr-2 -ml-1 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                {t('support.contactButton')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;